export const NUMERIC_VARIANT = {
  fontVariantNumeric: "lining-nums tabular-nums slashed-zero",
  fontFeatureSettings: "'cv04' on, 'ss01' on",
}
